// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3pEk4","requiredAsterisk":"Info_requiredAsterisk__3vecv"};